class BackendError extends Error {
    constructor(
        public message = 'An error has occurred.',
        public code?: number | string,
        public url?: string,
        public response?: unknown
    ) {
        super(message);
    }
}

type PagarmeErrorResponse = {
    errors: {
        type: string;
        parameterName: string;
        message: string;
    }[];
};

class PagarmeError extends BackendError {
    get pagarmeResponse(): PagarmeErrorResponse | undefined {
        return this.response as PagarmeErrorResponse | undefined;
    }
}

class InternalServerError extends BackendError {}

export { BackendError, PagarmeError, InternalServerError };
